import React, { useCallback } from "react";
import { useAuth } from "./../util/auth";
import { Typography } from "@material-ui/core";
import { Grid } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import base from "../util/base";

const FinalStep = () => {
  const auth = useAuth();
  const history = useHistory();

  const sendUser = useCallback(async () => {
    base("Users").create(
      {
        "Email": auth.user.email,
        "Firebase_ID": auth.user.id,
        "Premium Status": "Not Subscribed",
        "Parados Points": 0,
        "Booked First Appointment": "No",
      },
      function (err, record) {
        if (err) {
          console.error(err);
          return;
        }
        console.log(record.getId());
        history.push("/dashboard");
      }
    );
  }, [auth.user.email, auth.user.id, history]);

  return (
    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      spacing={2}
    >
      <Grid item={true} xs={12}>
        <Typography variant="h4">Thank you for registering</Typography>
      </Grid>
      <Grid item={true} xs={12}>
        <Typography variant="h6">
          You will now be forwarded to the dashboard.
        </Typography>
      </Grid>
      <Grid item={true} xs={12}>
        <Button
          variant="contained"
          color="primary"
          size="large"
          onClick={sendUser}
        >
          Go to Dashboard
        </Button>
      </Grid>
    </Grid>
  );
};
export default FinalStep;
